import { membershipFAQData } from '@/app/[locale]/membership/_data/MembershipFAQData';
import FaqSection from '@/app/[locale]/store/_components/HardwarePDP/FaqSection';

const FAQSection = () => {
  return <FaqSection items={membershipFAQData} containerClassName="py-20" />;
};

export default FAQSection;
